import {createAction, props} from "@ngrx/store";
import {HttpErrorResponse} from "@angular/common/http";
import {TenTariff} from "../../_models/tariff.models";

export const loadTariff = createAction(
    '[Tariff] Load Tariff',
    props<{ apartmentId: string }>()
);

export const loadTariffSuccess = createAction(
    '[Tariff] Load Tariff Success',
    props<{ apartmentId: string, tariff: TenTariff }>()
);

export const loadTariffFailure = createAction(
    '[Tariff] Load Tariff Failure',
    props<{ error: HttpErrorResponse }>()
);

export const setApartment = createAction(
    '[Tariff] Set Apartment Id',
    props<{ apartmentId: string }>()
);
